import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { TranslationProvider } from "angular-l10n";


@Injectable() export class FallbackTranslationProvider implements TranslationProvider {

    constructor(private http: Http) { }

    public getTranslation(language: string, args: any): Observable<any> {
        let url: string = "";
        switch (args.type) {
            case "global":
                url += args.path + ".json";
                break;
            case "lang":
                // Use languagecode entirely (for only language) or until the first dash (for lang-locale combo)
                url += args.path + language.substring(0, language.length > 3 ? language.indexOf('-') : language.length) + ".json";
                break;
            case "locale":
                // Check for dash that indicates locale specific language code.
                if (language.indexOf('-') > -1)
                    url += args.path + language + ".json";
                else
                    // No locale, so don't return any data.
                    // However it must be packaged as an observable or the fallback mechanism will stop working.
                    return Observable.create(observer => { observer.complete(); });
                break;
            default:
                url += args.path + language + ".json";
        }
        return this.http.get(url).map(res => res.json());
    }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/providers/fallbacktranslation.provider.ts